/* ============================================================
   CARTRI - Liquidacion -50%
   Bloque "Completa tu equipo" de la ficha, aviso de stock,
   garantia y badges de descuento.
   El carrito vive en liq-carrito-fix.js, aparte.
   La liquidacion no tiene fecha de fin (hasta fin de
   existencias): no hay cuenta atras en ninguna superficie.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.LIQ || {};
  if (!CFG.enabled) return;
  var S = CFG.strings || {};

  var money = function (c) {
    try {
      return new Intl.NumberFormat(CFG.locale || 'es-ES', {
        style: 'currency', currency: CFG.currency || 'EUR'
      }).format(c / 100);
    } catch (e) { return (c / 100).toFixed(2) + ' EUR'; }
  };
  var root = function () {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  };

  /* ---------- Completa tu equipo en la ficha ---------- */
  function initCross() {
    var box = document.querySelector('[data-liq-cross]');
    if (!box) return;
    var boxes = [].slice.call(box.querySelectorAll('input[type="checkbox"][data-price]'));
    var totalEl = box.querySelector('[data-liq-cross-total]');
    var saveEl = box.querySelector('[data-liq-cross-save]');
    var btn = box.querySelector('[data-liq-cross-add]');
    if (!boxes.length || !btn) return;

    function refresh() {
      var total = 0, was = 0, n = 0;
      boxes.forEach(function (c) {
        if (!c.checked) return;
        n++;
        total += Number(c.getAttribute('data-price')) || 0;
        was += Number(c.getAttribute('data-compare')) || Number(c.getAttribute('data-price')) || 0;
      });
      if (totalEl) totalEl.textContent = money(total);
      if (saveEl) {
        var save = was - total;
        saveEl.textContent = save > 0 ? (S.youSave || 'Ahorras {{amount}}').replace('{{amount}}', money(save)) : '';
      }
      btn.disabled = n === 0;
      btn.textContent = n === 0
        ? (S.crossEmpty || 'Selecciona un complemento')
        : (S.crossAdd || 'Anadir {{n}} al carrito').replace('{{n}}', n);
    }

    boxes.forEach(function (c) { c.addEventListener('change', refresh); });

    btn.addEventListener('click', function () {
      var items = [];
      boxes.forEach(function (c) { if (c.checked) items.push({ id: Number(c.value), quantity: 1 }); });
      if (!items.length) return;
      var txt = btn.textContent;
      btn.disabled = true;
      btn.textContent = S.adding || 'Anadiendo...';
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: items,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var d = document.querySelector('cart-drawer');
          if (d && typeof d.renderContents === 'function') {
            d.renderContents(data);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else { window.location.href = root() + 'cart'; }
        })
        .catch(function () { window.location.href = root() + 'cart'; })
        .then(function () { btn.disabled = false; btn.textContent = txt; });
    });

    refresh();
  }

  /* ---------- Stock y garantia en la ficha ---------- */
  function initProductExtras() {
    var p = CFG.product;
    if (!p) return;
    var form = document.querySelector('product-form') || document.querySelector('.product-form');
    if (!form || !form.parentNode) return;
    if (p.available && p.qty > 0 && p.qty <= (CFG.lowStockAt || 5) && !document.querySelector('.liq-stock')) {
      var stock = document.createElement('div');
      stock.className = 'liq-stock';
      stock.innerHTML = '<span class="liq-stock__dot"></span><span>' +
        (S.lowStock || 'Solo quedan {{n}} unidades').replace('{{n}}', p.qty) + '</span>';
      form.parentNode.insertBefore(stock, form);
    }
    if (CFG.guaranteeHTML && !document.querySelector('.liq-guarantee')) {
      var g = document.createElement('div');
      g.className = 'liq-guarantee';
      g.innerHTML = CFG.guaranteeHTML;
      form.parentNode.insertBefore(g, form.nextSibling);
    }
  }

  /* ---------- Stock del lote de Activity 2 en la ficha ---------- */
  function initGiftStock() {
    var box = document.querySelector('[data-liq-giftbox]');
    if (!box) return;
    var stockEl = box.querySelector('[data-liq-gift-stock]');
    var n = typeof CFG.giftStock === 'number' ? CFG.giftStock : null;
    if (n === null || isNaN(n)) return;
    n = Math.max(0, n);
    if (stockEl) {
      stockEl.textContent = n > 0
        ? (S.giftStockLeft || 'Quedan {{n}} Activity 2 para regalo').replace('{{n}}', n)
        : (S.giftStockOut || 'Lote de Activity 2 agotado');
    }
    if (n === 0) {
      box.classList.add('is-out');
      var zona = document.querySelector('[data-liq-ficha-gift]');
      if (zona) {
        zona.setAttribute('hidden', 'hidden');
        [].slice.call(zona.querySelectorAll('button')).forEach(function (b) { b.disabled = true; });
      }
    }
  }

  /* ---------- Badges de descuento y ahorro ---------- */
  function parseMoney(txt) {
    if (!txt) return NaN;
    var s = String(txt).replace(/[^0-9.,]/g, '').trim();
    if (!s) return NaN;
    if (s.indexOf(',') > -1 && s.indexOf('.') > -1) {
      s = s.indexOf(',') > s.indexOf('.') ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, '');
    } else if (s.indexOf(',') > -1) { s = s.replace(',', '.'); }
    var n = parseFloat(s);
    return isNaN(n) ? NaN : n;
  }

  function initSavings() {
    var prices = document.querySelectorAll('.price--on-sale:not([data-liq-done])');
    [].slice.call(prices).forEach(function (priceEl) {
      priceEl.setAttribute('data-liq-done', '1');
      var wasEl = priceEl.querySelector('.price__sale s.price-item--regular');
      var nowEl = priceEl.querySelector('.price__sale .price-item--sale');
      if (!wasEl || !nowEl) return;
      var was = parseMoney(wasEl.textContent);
      var now = parseMoney(nowEl.textContent);
      if (isNaN(was) || isNaN(now) || was <= now) return;
      var pct = Math.round(((was - now) / was) * 100);
      var save = Math.round((was - now) * 100);
      var container = priceEl.querySelector('.price__container') || priceEl;
      if (!priceEl.querySelector('.liq-ahorro')) {
        var span = document.createElement('span');
        span.className = 'liq-ahorro';
        span.textContent = (S.youSave || 'Ahorras {{amount}}').replace('{{amount}}', money(save));
        container.parentNode.insertBefore(span, container.nextSibling);
      }
      var card = priceEl.closest ? priceEl.closest('.card-wrapper') : null;
      if (!card) return;
      [].slice.call(card.querySelectorAll('.card__badge .badge')).forEach(function (b) {
        if (b.className.indexOf('liq-badge') > -1) return;
        if (/agotado|sold\s*out|epuise|esaurito/i.test(b.textContent)) {
          b.className = 'badge liq-badge liq-badge--agotado';
          return;
        }
        b.className = 'badge liq-badge';
        b.textContent = '-' + pct + '%';
      });
    });
  }

  function boot() {
    initCross();
    initProductExtras();
    initGiftStock();
    initSavings();
    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(initSavings, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
